import React, { useState, useEffect } from 'react';
import { FormInput, FormSubTitle, FormTitle } from '../validation/Form-Components';
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import FormContainer from '../components/FormContainer';
import SubHeader from '../components/SubHeader';
import { requiredValidator } from '../validation/Validators';
import govtService from '../services/GovtApiService';
import config from '../appconfig/config.json';
import { useHistory } from "react-router-dom";
import Loading from '../components/Loading';
import storage from '../factory/StorageFactory';
import apiService from '../services/ApiService';
import CusToast from '../components/CusToast';

let state= '',code = '', isFirstTime = true;

const MyInfoLanding = (props) => {
    let timer;
    //nric: S9812388A
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const myInfoError= {
        Code_1001:'1001',
        Code_1002:'1002',
        Code_1003:'1003',
        Code_1004:'1004',
        Code_1005:'1005',
        Code_1006:'1006',
        Code_1007:'1007',
        Code_1008:'1008',
        Code_1009:'1009',
        Code_1010:'1010',
        Code_1011:'1011',
        Code_M01:'M01',
        Code_M02:'M02',
        Code_M03:'M03',
        Code_M04:'M04',
        Code_M05:'M05',
        Code_M06:'M06',
        Code_M07:'M07',
        Code_M08:'M08',
        Code_M09:'M09',
        Code_M10:'M10',
        Code_M11:'M11',
        Code_M27:'M27'
    }
    
    useEffect(() => {
 
        const queryString = require('query-string');
        const parsed = queryString.parse(props.location.search);
        
        if(parsed.error !== undefined) {
            //redirect to product url
            storage.clearAll();
            window.location.href = config.link.BacktoHome;
            return;
        }

        state = parsed.state;
        code = parsed.code;
 
        if(storage.getIsFirstTime() !== null) {
            isFirstTime = storage.getIsFirstTime() === 'true'? true:false;
        }
        else {
            isFirstTime = true;
        }
      
        checkServerStatus();

        return () => {
            clearTimeout(timer);
        }
    }, []);

    const checkServerStatus = ( ) => {
        if(config.SERVER_STATUS === 'UAT' || config.SERVER_STATUS === 'PROD') {
            getMyInfo(code)
        }
        else { //SIM, DEV 
            if(props.location.state !== undefined) {
                code = props.location.state.code;
            }
            setIsLoading(false);
        }
    }

    const handleSubmit = (dataItem) => {
      
        let data = JSON.parse(JSON.stringify(dataItem));
        let nric = data.nric;
   
        setIsLoading(true);
       // getMyInfo(nric);

        if(code && code !==null && code!== '') {
            if(nric.trim() !== code.trim()){
                showErrMsg('Invalid input. Please enter correct input.')
            }
            else {
                //SIT or DEV
                getMyInfo(nric);
            }
        }
        else {
            getMyInfo(nric);
        }
    } 
    
    const getMyInfo = (nric) => {
 
        if(state === '' || code === '') {
            return;
        } 

        govtService.retrieveMyInfo(state, nric).then(res => {
           
            let resData = res.data;
            if(resData.statuscode.toUpperCase() === 'OK') {
              
                validateMyInfo(state);
          
            }
            else {
                setIsLoading(false);
                goErrorPage(myInfoError.Code_M01);
            }
        }).catch(err => {
            setIsLoading(false);
            goErrorPage(myInfoError.Code_M01);
        })
    }

    const validateMyInfo = (state) => {
        //state = '';
        apiService.validateMyInfoData(state).then( res=> {
            let resData = res.data;
            if(resData.isSucess) {
                let code = resData.model.code;
                if(code === '0') {
                    if(isFirstTime) {  //only first AP will call preknockout
                        if(config.IsWAAEnabled) {
                            preQualificationKnockout(state);
                        }
                        else {
                            setIsLoading(false);
                            goNext(state);
                        }
                    }
                    else {
                        setIsLoading(false);
                        goNext(state);
                    }
                }
                else {
                    setIsLoading(false);
                    goErrorPage(code);
                }
            }
            else {
                setIsLoading(false);
                goErrorPage(myInfoError.Code_M01);
            }
           
        }).catch(err => {
            setIsLoading(false);
            goErrorPage(myInfoError.Code_M01);
        })
    }

    const preQualificationKnockout = (state) => {
        let stage = storage.getAppStage(); //APP status from config 
        apiService.preKnockout(stage).then(res => {
            let resData = res.data;
            setIsLoading(false);
            
            if(resData.model.status === 'Fail'){
                goPreKnockoutFailed('500');
                return;
            }
            goNext(state);
        }).catch(err=> {
            console.log('@preQualificationKnockout ',err)
            setIsLoading(false);
            goPreKnockoutFailed('500');
        })
    }

    const goNext = (state) => {
        if(isFirstTime) {
            history.push(config.route.CompanyDetails+'?state='+state);
        }
        else {
            if(storage.getIsFProdBTL() === 't') { //BTL flow
                history.push(config.route.NSPersonDetails+'?state='+state);
            }
            else { //Hybrid Flow
                history.push(config.route.SubAPLanding+'?state='+state);
            }
        }
    }

    const goErrorPage = (errorType) => {

        if(errorType === myInfoError.Code_1010 || errorType === myInfoError.Code_M10 ||errorType === myInfoError.Code_M27) {
            history.push(config.route.InvalidDirectors,{errType:errorType});
            return;
        }

        history.push(config.route.InvalidEntity,{errType:errorType});
    }

    const goPreKnockoutFailed = (errorType) => {
        history.push(config.route.PreKnockoutFailed,{errType:errorType});
    }

    const showErrMsg = (msg) => {
        setIsLoading(false);
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    if(isLoading) {
        return(
            <Loading />
        )
    }

    return (
     <div className="container-fluid">
               <SubHeader />
               <Form onSubmit={handleSubmit} 
                render={(formRenderProps)=> (
                    <FormElement>
                        <FormContainer>
                            <fieldset>
                                <Field component={FormTitle} 
                                    id={'ftitle'} 
                                    name={'Maybank online application'} />
                                <Field component={FormSubTitle} id={'fstST1'} 
                                    name={'Enter UEN/NRIC to apply via MyInfo'} />
                                
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="box">
                                            <Field name={'nric'} placeholder={'Please input'} 
                                                component={FormInput} 
                                                validator={requiredValidator} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row around-xs inputPair elementVisible" style={{ marginTop: "1rem" }}>
                                    <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="text-center">
                                        <div className="box">
                                            <button type={'submit'} className="k-button btn btn-success btn-float-right" >Confirm</button>
                                        </div>
                                        </div>
                                    </div>
                                </div> 
                       
                            </fieldset>
                          
                        </FormContainer>
                    </FormElement>
                )}>
               </Form>
               <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} /> 
        </div>
 
    )
}

export default MyInfoLanding